(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nx-bundle-compact"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-product-complement')) {
    customElements.define('nx-product-complement', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.product = JSON.parse(this.querySelector('[data-nxc-product]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-nxc-labels]').textContent);
        this.selects = [...this.querySelectorAll('[data-nxc-option]')];
        this.button = this.querySelector('.nx-complement__add');
        this.status = this.querySelector('.nx-complement__status');
        this.quantity = Number(this.dataset.quantity) || 1;
        this.colors = {'blanc':'#f6f4ef','blanc casse':'#f2ede2','ivoire':'#efe9dc','creme':'#efe6d6','champagne':'#dcc9a8','khaki':'#b9a88e','kaki':'#b0a894','beige':'#d9c9b2','beige sable':'#d8c8ae','sable':'#d5c4a5','taupe':'#a9998a','milk tea':'#d3bfa3','caramel':'#a96f3d','coffee':'#6b5138','cafe fonce':'#5d4a3a','marron':'#7a5c42','rose':'#e5b6ad','rose clair':'#e8c6c3','rose poudre':'#e5b6ad','terracotta':'#c4674a','orange':'#e08b4e','jaune':'#e2c46f','rouge':'#a63d33','vert sauge':'#a9b5a2','vert':'#9fae9b','vert feuille':'#7f9377','vert eau':'#b8cec5','vert d eau':'#b8cec5','vert canard':'#4e7d78','bleu':'#8298b0','bleu gris':'#93a3b5','bleu fonce':'#34455e','bleu nuit':'#1e2a44','gris':'#b9b9b7','gris clair':'#c9c9c7','gris argent':'#c3c6c8','gris argente':'#c3c6c8','gris fume':'#8e8e8c','gris fonce':'#6d6d6b','gris perle':'#c6c6c4','mauve':'#b5a8c9','noir':'#2b2b2b','naturel':'#d8c9b0','lin naturel':'#d8c9b0'};
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency: this.dataset.currency || 'EUR'});
        this.form = this.closest('form');
        this.abort = new AbortController();
        const colorSelect = this.selects.find(s => ['couleur','color','colour'].includes(this.norm(s.dataset.nxcName)));
        if (colorSelect) {
          const index = Number(colorSelect.dataset.nxcOption);
          const neutral = ['blanc','ivoire','naturel','beige sable','taupe'].map(name => [...colorSelect.options].find(o => this.norm(o.value) === name && this.product.variants.some(v => v.available && v.options[index] === o.value))).find(Boolean);
          if (neutral) colorSelect.value = neutral.value;
        }
        this.selects.forEach(select => select.addEventListener('change', () => this.update(), {signal:this.abort.signal}));
        this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
        if (this.form) this.form.addEventListener('change', event => {
          if (event.target.closest('nx-product-complement')) return;
          if (event.target.matches('[data-option]')) this.sync(event.target);
        }, {signal:this.abort.signal});
        this.sync();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.initialized = false;
      }
      norm(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase(); }
      size(value) { return this.norm(value).replace(/\s|cm/g, '').replace('×','x'); }
      sync(changed) {
        const inputs = changed ? [changed] : [...(this.form?.querySelectorAll('[data-option]:checked, select[data-option]') || [])];
        inputs.forEach(input => {
          const optionName = this.norm(input.dataset.option);
          const color = ['couleur','color','colour'].includes(optionName);
          const size = this.dataset.syncSize === 'true' && (optionName.includes('taille') || optionName === 'titre' || optionName === 'size');
          if (!color && !size) return;
          const select = this.selects.find(s => color ? ['couleur','color','colour'].includes(this.norm(s.dataset.nxcName)) : !['couleur','color','colour'].includes(this.norm(s.dataset.nxcName)));
          if (!select) return;
          const normalize = value => size ? this.size(value) : this.norm(value);
          const target = [...select.options].find(o => normalize(o.value) === normalize(input.value))
            || (size ? [...select.options].find(o => this.size(o.value).replace('66x66','65x65') === this.size(input.value).replace('66x66','65x65')) : null);
          if (!target) return;
          const index = Number(select.dataset.nxcOption);
          if (!this.product.variants.some(v => v.available && v.options[index] === target.value)) return;
          select.value = target.value;
        });
        this.update();
      }
      update() {
        const values = this.selects.map(select => select.value);
        this.variant = this.product.variants.find(v => this.selects.every((s,i) => v.options[Number(s.dataset.nxcOption)] === values[i]));
        const variant = this.variant;
        this.button.disabled = this.busy || !variant?.available;
        this.button.textContent = !variant ? this.labels.unavailable : variant.available ? this.labels.add : this.labels.soldOut;
        this.button.removeAttribute('data-added');
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        this.selects.forEach(select => [...select.options].forEach(option => {
          const index = Number(select.dataset.nxcOption);
          option.disabled = !this.product.variants.some(v => v.available && v.options[index] === option.value && this.selects.every(other => Number(other.dataset.nxcOption) >= index || v.options[Number(other.dataset.nxcOption)] === other.value));
        }));
        const colorSelect = this.selects.find(select => ['couleur','color','colour'].includes(this.norm(select.dataset.nxcName)));
        const colorDot = this.querySelector('[data-nxc-color-dot]');
        if (colorSelect && colorDot) {
          colorDot.style.background = this.colors[this.norm(colorSelect.value).replace(/[’'\-]/g,' ').replace(/\s+/g,' ')] || '#f1eee7';
          colorDot.setAttribute('title', colorSelect.value);
        }
        if (!variant) return;
        this.querySelector('.nx-complement__price').textContent = '+ ' + this.format.format(variant.price * this.quantity / 100);
        let image = variant.featured_image;
        const colorIndex = this.product.options.findIndex(o => ['couleur','color','colour'].includes(this.norm(o.name || o)));
        if (!image && colorIndex >= 0) image = this.product.variants.find(v => v.options[colorIndex] === variant.options[colorIndex] && v.featured_image)?.featured_image;
        if (!image && colorIndex < 0) image = this.product.featured_image;
        const img = this.querySelector('.nx-complement__image');
        const source = typeof image === 'string' ? image : image?.src;
        if (img && source) {
          const url = new URL(source, location.origin);
          url.searchParams.set('width', '240');
          img.removeAttribute('srcset');
          img.src = url.href;
          img.alt = this.product.title + ' — ' + variant.title;
          img.hidden = false;
        } else if (img) img.hidden = true;
        this.querySelectorAll('a').forEach(a => {const url = new URL(this.product.url || '/products/' + this.product.handle, location.origin); url.searchParams.set('variant',variant.id); a.href = url.pathname + url.search;});
      }
      async add() {
        if (this.busy || !this.variant?.available) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.labels.adding;
        this.setAttribute('aria-busy','true');
        this.selects.forEach(select => select.disabled = true);
        try {
          const core = window.themeCore;
          if (core?.CartApi) {
            await core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, {id:this.variant.id,quantity:this.quantity});
          } else {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({items:[{id:this.variant.id,quantity:this.quantity}]})
            });
            const data = await response.json();
            if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : this.labels.error);
          }
          this.button.textContent = this.labels.added;
          this.button.setAttribute('data-added','');
          this.status.textContent = this.labels.success;
          if (core?.CartApi) core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(() => {});
          else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (error) {
          this.status.textContent = error.description || error.message || this.labels.error;
          this.status.setAttribute('data-error','');
          this.button.textContent = this.labels.add;
          this.button.disabled = false;
        } finally {
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.selects.forEach(select => select.disabled = false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-cart-complement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-cart-complement')) {
    customElements.define('nx-cart-complement', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.product = JSON.parse(this.querySelector('[data-nx-cart-product]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-nx-cart-labels]').textContent);
        this.selects = [...this.querySelectorAll('[data-nx-cart-option]')];
        this.button = this.querySelector('.nx-cart-complement__add');
        this.status = this.querySelector('.nx-cart-complement__status');
        this.price = this.querySelector('.nx-cart-complement__price');
        this.basePrice = this.price.textContent;
        this.format = new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'currency',currency:this.dataset.currency || 'EUR'});
        this.abort = new AbortController();
        this.selects.forEach(select => select.addEventListener('change', () => this.update(), {signal:this.abort.signal}));
        this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.initialized = false; }
      update() {
        const complete = this.selects.every(select => select.value !== '');
        this.variant = complete ? this.product.variants.find(v => this.selects.every(s => v.options[Number(s.dataset.nxCartOption)] === s.value)) : null;
        this.selects.forEach(select => [...select.options].forEach(option => {
          if (!option.value) return;
          const index = Number(select.dataset.nxCartOption);
          option.disabled = !this.product.variants.some(v => v.available && v.options[index] === option.value && this.selects.every(other => Number(other.dataset.nxCartOption) >= index || !other.value || v.options[Number(other.dataset.nxCartOption)] === other.value));
        }));
        this.button.disabled = this.busy || !this.variant?.available;
        this.button.textContent = !complete ? this.labels.choose : this.variant?.available ? this.labels.add : this.labels.unavailable;
        this.price.textContent = this.variant ? this.format.format(this.variant.price / 100) : this.basePrice;
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        const image = this.variant?.featured_image || this.product.featured_image;
        const source = typeof image === 'string' ? image : image?.src;
        const img = this.querySelector('img');
        if (img && source) {
          const url = new URL(source, location.origin); url.searchParams.set('width','160');
          img.removeAttribute('srcset'); img.src = url.href;
          img.alt = this.product.title + (this.variant ? ' — ' + this.variant.title : '');
        }
        const link = this.querySelector('.nx-cart-complement__link');
        const url = new URL(this.product.url || '/products/' + this.product.handle, location.origin);
        if (this.variant) url.searchParams.set('variant',this.variant.id);
        link.href = url.pathname + url.search;
      }
      async add() {
        if (this.busy || !this.variant?.available) return;
        this.busy = true; this.button.disabled = true;
        this.button.textContent = this.labels.adding;
        this.status.textContent = ''; this.status.removeAttribute('data-error');
        this.setAttribute('aria-busy','true');
        this.selects.forEach(select => select.disabled = true);
        try {
          const core = window.themeCore;
          if (core?.CartApi) {
            await core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART,{id:this.variant.id,quantity:1});
            core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(() => {});
          } else {
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})
            });
            const result = await response.json();
            if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : this.labels.error);
            location.assign((window.Shopify?.routes?.root || '/') + 'cart');
          }
          this.button.textContent = this.labels.added;
          this.status.textContent = this.labels.success;
          // Keep the button locked until native section rendering removes this suggestion.
        } catch (error) {
          this.busy = false; this.button.disabled = false;
          this.button.textContent = this.labels.add;
          this.status.textContent = typeof error.description === 'string' ? error.description : error.message || this.labels.error;
          this.status.setAttribute('data-error','');
          this.selects.forEach(select => select.disabled = false);
        } finally { this.removeAttribute('aria-busy'); }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-cart-popup-guard"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-cart-popup-guard')) {
    customElements.define('nx-cart-popup-guard', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.scheduled = false;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
        this.schedule();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
      schedule() {
        if (this.scheduled) return;
        this.scheduled = true;
        requestAnimationFrame(() => { this.scheduled = false; this.protectCheckout(); });
      }
      protectCheckout() {
        const cart = document.querySelector('#CartDrawer');
        if (!cart?.classList.contains('is-active')) return;
        document.querySelectorAll('[role="dialog"] [data-testid="POPUP"]').forEach(popup => {
          const dialog = popup.closest('[role="dialog"]');
          if (!dialog || dialog.dataset.nxCartDismissed) return;
          dialog.dataset.nxCartDismissed = 'true';
          const close = [...dialog.querySelectorAll('button')].find(button => {
            const label = [button.getAttribute('aria-label'), button.getAttribute('title'), button.textContent].filter(Boolean).join(' ').toLowerCase();
            return label.includes('close') || label.includes('fermer') || label.trim() === '×';
          });
          if (close) close.click();
          else {
            dialog.hidden = true;
            dialog.style.setProperty('display','none','important');
            document.body.classList.remove('klaviyo-prevent-body-scrolling');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-french-days-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.nxFrenchDays) return;
  const configElement = document.getElementById('NxFrenchDaysConfig');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const labels = config.labels;
  const endsAt = Date.parse('2026-10-04T21:59:00Z');
  const parureIds = new Set([15486895817030, 15673155649862, 15688337064262, 15673182519622]);
  const giftId = config.material === 'satin' ? 15673187369286 : 15673181700422;
  const instances = new Set();
  const sectionEvents = new Set();
  const norm = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const size = value => norm(value).replace(/\s|cm/g, '').replace(/×/g, 'x');
  const caseSize = value => String(value || '').match(/(?:Taies\s*)?(50\s*[x×]\s*70|65\s*[x×]\s*65)/i)?.[1] || '';
  const active = () => config.enabled === true && Date.now() < endsAt;
  const route = path => (window.Shopify?.routes?.root || '/') + path;
  let busy = false;
  let cartState = null;
  let cartRead = null;
  let cartGeneration = 0;
  let gateTimer;
  let frame;
  let busBound = false;
  const text = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
  function quantities(cart) {
    let parures = 0;
    let gifts = 0;
    for (const item of cart.items || []) {
      if (parureIds.has(Number(item.product_id))) parures += Number(item.quantity) || 0;
      if (Number(item.product_id) === giftId) gifts += Number(item.quantity) || 0;
    }
    return {parures, gifts, remaining: Math.max(0, Math.min(parures, 4) - gifts)};
  }
  function applyCart(cart) {
    cartState = cart;
    for (const instance of instances) instance.updateCart(quantities(cart));
  }
  function readCart(fresh = false) {
    if (cartRead && !fresh) return cartRead;
    const generation = ++cartGeneration;
    const pending = fetch(route('cart.js'), {headers: {Accept: 'application/json'}, cache: 'no-store'})
      .then(response => { if (!response.ok) throw new Error(labels.cartError); return response.json(); })
      .then(cart => {
        if (generation !== cartGeneration) return readCart();
        applyCart(cart);
        return cart;
      })
      .finally(() => { if (generation === cartGeneration) cartRead = null; });
    cartRead = pending;
    return pending;
  }
  function gate() {
    const enabled = active();
    document.querySelectorAll('[data-nx-fd]').forEach(element => {
      const show = enabled && (!element.matches('nx-french-days-gift') || element.dataset.context !== 'cart' || Number(element.dataset.remaining) > 0);
      if (element.hidden === show) element.hidden = !show;
    });
    for (const instance of instances) { instance.bindProduct(); instance.syncParent(); instance.update(); }
    clearTimeout(gateTimer);
    if (enabled) gateTimer = setTimeout(gate, Math.max(1, Math.min(60000, endsAt - Date.now())));
    bindBus();
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(() => { frame = null; gate(); }); }
  function bindBus() {
    const bus = window.themeCore?.EventBus;
    if (!bus || busBound) return;
    busBound = true;
    bus.listen('cart:updated', () => { readCart(true).catch(() => {}); });
    bus.listen('product:loaded', schedule);
  }
  window.nxFrenchDays = {active, refresh: gate};
  class FrenchDaysGift extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-nx-fd-product]');
      if (!data) {
        if (!this.initScheduled) {
          this.initScheduled = true;
          queueMicrotask(() => {
            this.initScheduled = false;
            if (this.isConnected && this.querySelector('[data-nx-fd-product]')) this.connectedCallback();
          });
        }
        return;
      }
      this.ready = true;
      this.abort = new AbortController();
      this.product = JSON.parse(this.querySelector('[data-nx-fd-product]').textContent);
      this.selects = [...this.querySelectorAll('[data-nx-fd-option]')];
      this.button = this.querySelector('[data-nx-fd-add]');
      this.include = this.querySelector('[data-nx-fd-include]');
      this.nativeButtons = new Map();
      this.status = this.querySelector('[data-nx-fd-status]');
      this.color = this.selects.find(select => /^(couleur|color|colour)$/.test(norm(select.dataset.optionName)));
      this.size = this.selects.find(select => /taille|size|dimension/.test(norm(select.dataset.optionName)));
      this.counts = {parures: Number(this.dataset.parures), gifts: Number(this.dataset.gifts), remaining: Number(this.dataset.remaining)};
      const first = this.product.variants.find(variant => variant.available);
      if (first) this.selects.forEach(select => { select.value = first.options[Number(select.dataset.nxFdOption)]; });
      const defaultColor = config.material === 'satin' ? ['Blanc', 'Champagne'].find(value => [...(this.color?.options || [])].some(option => norm(option.value) === norm(value))) : this.dataset.parentColor;
      this.setColor(defaultColor);
      this.setSize(caseSize(this.dataset.parentComposition) || '50 x 70');
      this.selects.forEach(select => select.addEventListener('change', () => {
        if (select === this.color) this.colorChosen = true;
        this.clearStatus();
        this.update();
      }, {signal: this.abort.signal}));
      this.button?.addEventListener('click', () => this.add(), {signal: this.abort.signal});
      this.include?.addEventListener('change', () => { this.clearStatus(); this.update(); }, {signal: this.abort.signal});
      instances.add(this);
      if (cartState) this.updateCart(quantities(cartState));
      this.bindProduct();
      this.syncParent();
      this.update();
      schedule();
    }
    disconnectedCallback() { this.abort?.abort(); instances.delete(this); this.ready = false; }
    bindProduct() {
      if (this.dataset.context !== 'product') return;
      this.form = this.closest('form[data-js-product-form]');
      this.scope = this.form || this.closest('product-form') || this.closest('[data-section-type="product"]') || this.closest('.shopify-section');
      this.configurator = this.scope?.querySelector('nx-parure-configurator');
      const id = this.configurator?.dataset.sectionId;
      const bus = window.themeCore?.EventBus;
      if (id && bus && !sectionEvents.has(id)) {
        sectionEvents.add(id);
        bus.listen('pdp:section-' + id + ':change-variant', payload => {
          for (const instance of instances) if (instance.configurator?.dataset.sectionId === id) instance.syncParent(payload?.variant);
        });
      }
    }
    syncParent(variant) {
      if (this.dataset.context !== 'product') return;
      if (!variant) {
        try { variant = JSON.parse(this.configurator?.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) { return; }
      }
      if (variant) this.parentVariant = variant;
      const options = variant?.options || [variant?.option1, variant?.option2, variant?.option3];
      const nextSize = caseSize(options[2]);
      const nextColor = options[0];
      if (nextSize && size(nextSize) !== this.parentSize) { this.parentSize = size(nextSize); this.setSize(nextSize); }
      if (nextColor && nextColor !== this.parentColor) { this.parentColor = nextColor; if (!this.colorChosen && config.material !== 'satin') this.setColor(nextColor); }
      this.update();
    }
    setColor(value) {
      if (!this.color || !value) return;
      const option = [...this.color.options].find(option => norm(option.value) === norm(value));
      const index = Number(this.color.dataset.nxFdOption);
      if (option && this.product.variants.some(variant => variant.available && variant.options[index] === option.value)) this.color.value = option.value;
    }
    setSize(value) {
      if (!this.size) return;
      const option = [...this.size.options].find(option => size(option.value) === size(value));
      if (option) this.size.value = option.value;
    }
    updateCart(counts) {
      this.counts = counts;
      this.dataset.remaining = String(counts.remaining);
      text(this.querySelector('[data-nx-fd-remaining]'), (counts.remaining === 1 ? labels.remainingOne : labels.remainingMany).replace('__count__', counts.remaining));
      this.update();
      schedule();
    }
    clearStatus() { this.quotaStatus = false; text(this.status, ''); this.status.removeAttribute('data-error'); }
    update() {
      if (!this.ready) return;
      this.variant = this.product.variants.find(variant => this.selects.every(select => variant.options[Number(select.dataset.nxFdOption)] === select.value));
      const fulfilled = this.counts.parures > 0 && this.counts.remaining === 0;
      if (this.button) this.button.disabled = busy || !active() || !this.variant?.available || fulfilled;
      if (this.include) this.include.disabled = busy;
      this.selects.forEach(select => { select.disabled = busy; });
      this.updatePurchaseButtons();
      if (!this.adding) text(this.button, fulfilled ? labels.fulfilled : this.variant?.available ? labels.add : labels.unavailable);
      this.selects.forEach(select => [...select.options].forEach(option => {
        const index = Number(select.dataset.nxFdOption);
        option.disabled = !this.product.variants.some(variant => variant.available && variant.options[index] === option.value && this.selects.every(other => Number(other.dataset.nxFdOption) >= index || variant.options[Number(other.dataset.nxFdOption)] === other.value));
      }));
    }
    prospectiveGiftQuantity(quantity = this.formQuantity()) {
      return Math.min(quantity, Math.max(0, Math.min(this.counts.parures + quantity, 4) - this.counts.gifts));
    }
    formQuantity() {
      const field = this.form?.elements.namedItem('quantity');
      const value = Number(field?.value || 1);
      return Number.isInteger(value) && value > 0 ? value : 1;
    }
    updatePurchaseButtons() {
      if (!this.form || !this.include || !this.parentVariant) return;
      const variant = this.parentVariant;
      const formatter = this.configurator?.money || new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency: this.dataset.currency || 'EUR'});
      const price = formatter.format(Number(variant.price || 0) / 100);
      const withGift = active() && this.include.checked && this.prospectiveGiftQuantity() > 0;
      const unavailable = variant.available === false || this.configurator?.busy === true;
      this.form.querySelectorAll('button.add-to-cart[type="submit"]').forEach(button => {
        if (!this.nativeButtons.has(button)) this.nativeButtons.set(button, {label: button.textContent, disabled: button.disabled});
        if (unavailable) return;
        button.disabled = busy || (withGift && !this.variant?.available);
        if (busy && this.submitting) text(button, labels.adding);
        else if (withGift) text(button, labels.bundleAdd.replace('__price__', price));
        else text(button, (this.configurator?.dataset.add ? this.configurator.dataset.add + ' — ' + price : labels.parureOnly.replace('__price__', price)));
      });
      if (active() && this.include.checked && this.prospectiveGiftQuantity() === 0 && !this.status.hasAttribute('data-error')) {
        text(this.status, this.counts.gifts >= 4 ? labels.limitReached : labels.alreadyAdded);
        this.quotaStatus = true;
      } else if (this.quotaStatus && !this.status.hasAttribute('data-error')) { this.quotaStatus = false; this.clearStatus(); }
    }
    validatePurchaseForm() {
      if (!this.form.reportValidity()) return false;
      let valid = true;
      this.form.querySelectorAll('.js-custom-field-block').forEach(group => {
        const input = group.querySelector('.js-custom-field-input');
        const checkbox = group.querySelector('.js-custom-field-checkbox');
        if (!input || !checkbox) return;
        const mismatch = checkbox.checked !== Boolean(input.value.trim());
        input.classList.toggle('error', mismatch && checkbox.checked);
        checkbox.classList.toggle('error', mismatch && !checkbox.checked);
        if (mismatch) valid = false;
      });
      return valid;
    }
    purchaseItem() {
      const data = new FormData(this.form);
      const quantity = Number(data.get('quantity') || 1);
      const id = Number(data.get('id'));
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isInteger(quantity) || quantity <= 0) throw new Error(labels.bundleError);
      const item = {id, quantity};
      const properties = {};
      for (const [name, value] of data.entries()) {
        const match = name.match(/^properties\[(.*)\]$/);
        if (match) properties[match[1]] = value;
      }
      if (Object.keys(properties).length) item.properties = properties;
      const sellingPlan = data.get('selling_plan');
      if (sellingPlan) item.selling_plan = sellingPlan;
      return item;
    }
    async submitBundle() {
      if (busy || !this.form || !this.validatePurchaseForm()) return;
      this.syncParent();
      if (this.parentVariant?.available === false) return;
      let item;
      try { item = this.purchaseItem(); } catch (error) { text(this.status, error.message); this.status.setAttribute('data-error', ''); return; }
      const giftVariant = this.variant ? {id: this.variant.id, available: this.variant.available} : null;
      busy = true;
      this.submitting = true;
      this.clearStatus();
      this.form.setAttribute('aria-busy', 'true');
      for (const instance of instances) instance.update();
      try {
        const counts = quantities(await readCart(true));
        const giftQuantity = active() && this.include.checked ? Math.min(item.quantity, Math.max(0, Math.min(counts.parures + item.quantity, 4) - counts.gifts)) : 0;
        if (giftQuantity && !giftVariant?.available) throw new Error(labels.stockError);
        const items = [item];
        if (giftQuantity) items.push({id: giftVariant.id, quantity: giftQuantity});
        const hasFiles = items.some(entry => Object.values(entry.properties || {}).some(value => typeof value !== 'string'));
        let body;
        const headers = {Accept: 'application/json'};
        if (hasFiles) {
          body = new FormData();
          items.forEach((entry, index) => {
            body.append('items[' + index + '][id]', entry.id);
            body.append('items[' + index + '][quantity]', entry.quantity);
            if (entry.selling_plan) body.append('items[' + index + '][selling_plan]', entry.selling_plan);
            for (const [name, value] of Object.entries(entry.properties || {})) body.append('items[' + index + '][properties][' + name + ']', value);
          });
        } else { headers['Content-Type'] = 'application/json'; body = JSON.stringify({items}); }
        const response = await fetch(route('cart/add.js'), {method: 'POST', headers, body});
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : labels.bundleError);
        const core = window.themeCore;
        if (core?.CartApi) await core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(() => {});
        await readCart(true).catch(() => {});
        if (!core?.CartApi && core?.EventBus) core.EventBus.emit('cart:refresh');
        else if (!core?.CartApi) window.location.assign(route('cart'));
      } catch (error) {
        text(this.status, typeof error.description === 'string' ? error.description : error.message || labels.bundleError);
        this.status.setAttribute('data-error', '');
        await readCart(true).catch(() => {});
      } finally {
        busy = false;
        this.submitting = false;
        this.form.removeAttribute('aria-busy');
        for (const instance of instances) instance.update();
        schedule();
      }
    }
    async add() {
      if (busy || !active() || !this.variant?.available) return;
      busy = true;
      this.adding = true;
      this.clearStatus();
      this.setAttribute('aria-busy', 'true');
      text(this.button, labels.adding);
      for (const instance of instances) instance.update();
      try {
        const counts = quantities(await readCart(true));
        if (!active()) return;
        if (!counts.parures) throw new Error(labels.addParure);
        if (!counts.remaining) throw new Error(labels.alreadyAdded);
        const core = window.themeCore;
        if (core?.CartApi) {
          const result = await core.CartApi.makeRequest(core.CartApi.actions.ADD_TO_CART, {id: this.variant.id, quantity: 1});
          if (result?.status >= 400) throw new Error(result.description || labels.stockError);
        } else {
          const response = await fetch(route('cart/add.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: this.variant.id, quantity: 1}]})});
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : labels.stockError);
        }
        if (core?.CartApi) await core.CartApi.makeRequest(core.CartApi.actions.GET_CART).catch(() => {});
        await readCart(true).catch(() => {});
        text(this.status, labels.added);
        if (!core?.CartApi && core?.EventBus) core.EventBus.emit('cart:refresh');
        else if (!core?.CartApi) window.location.assign(route('cart'));
      } catch (error) {
        text(this.status, typeof error.description === 'string' ? error.description : error.message || labels.error);
        this.status.setAttribute('data-error', '');
      } finally {
        busy = false;
        this.adding = false;
        this.removeAttribute('aria-busy');
        for (const instance of instances) instance.update();
        schedule();
      }
    }
  }
  document.addEventListener('submit', event => {
    const instance = [...instances].find(candidate => candidate.dataset.context === 'product' && candidate.form === event.target);
    if (!instance || (!busy && (!active() || !instance.include?.checked))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!busy) instance.submitBundle();
  }, true);
  document.addEventListener('change', event => {
    if (event.target.matches('[name="quantity"]')) for (const instance of instances) if (instance.form === event.target.form) instance.update();
  });
  if (!customElements.get('nx-french-days-gift')) customElements.define('nx-french-days-gift', FrenchDaysGift);
  new MutationObserver(records => { if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule(); }).observe(document.body, {childList: true, subtree: true});
  window.addEventListener('pageshow', () => { gate(); if (active()) readCart().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { gate(); if (!document.hidden && active()) readCart().catch(() => {}); });
  document.addEventListener('theme:all:loaded', () => { bindBus(); gate(); });
  document.addEventListener('shopify:section:load', schedule);
  gate();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-parure-configurator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-parure-configurator')) {
  customElements.define('nx-parure-configurator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      if (!this.form) return;
      this.abort = new AbortController();
      this.sheet = this.querySelector('[data-nxp-sheet]');
      this.cases = this.querySelector('[data-nxp-cases]');
      this.status = this.querySelector('[data-nxp-status]');
      this.variants = JSON.parse(this.querySelector('[data-nxp-all-variants]').textContent);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:this.dataset.currency || 'EUR'});
      this.addEventListener('change', event => this.prepare(event), {capture:true,signal:this.abort.signal});
      this.form.addEventListener('submit', event => {
        if (!this.busy) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.status.textContent = this.dataset.loading;
      }, {capture:true,signal:this.abort.signal});
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.querySelector('.js-product-options'), {childList:true});
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timeout);
      this.ready = false;
    }
    markSelected(select) {
      [...select.options].forEach(option => {
        if (option.selected) option.setAttribute('selected', 'selected');
        else option.removeAttribute('selected');
      });
    }
    composition(variant) { return String(variant?.option3 || variant?.options?.[2] || ''); }
    options(variant) { return variant.options || [variant.option1, variant.option2, variant.option3]; }
    isFour(variant) { return this.composition(variant).startsWith('Drap-housse '); }
    chooseVariant(candidates, focusId) {
      const current = this.options(this.variant);
      const sameSize = variant => this.options(variant)[0] === current[0] && this.options(variant)[1] === current[1];
      const sameColor = variant => this.options(variant)[0] === current[0];
      const next = candidates.find(sameSize) || candidates.find(sameColor) || candidates[0];
      if (!next) return;
      const target = this.options(next);
      this.querySelectorAll('input[data-option]').forEach(radio => radio.checked = radio.value === target[0]);
      const duvet = this.querySelector('[data-nxp-duvet]');
      const native = this.querySelector('[data-nxp-composition]');
      duvet.value = target[1];
      native.value = target[2];
      this.markSelected(duvet);
      this.markSelected(native);
      this.pendingFocusId = focusId;
      native.dispatchEvent(new Event('change', {bubbles:true}));
    }
    switchOffer(input) {
      const four = input.value === '4';
      let candidates = this.variants.filter(variant => this.isFour(variant) === four);
      const configured = candidates.filter(variant => this.composition(variant) !== 'Parure 3 pièces');
      if (configured.length) candidates = configured;
      this.chooseVariant(candidates, input.id);
    }
    prepare(event) {
      if (event.target.matches('[data-nxp-offer]')) { this.switchOffer(event.target); return; }
      if (!event.target.matches('[data-option], [data-nxp-sheet], [data-nxp-cases]')) return;
      if (event.target === this.sheet || event.target === this.cases) {
        const value = this.isFour(this.variant) ? 'Drap-housse ' + this.sheet.value + ' | Taies ' + this.cases.value : this.cases.value === 'original' ? 'Parure 3 pièces' : 'Taies ' + this.cases.value;
        const candidates = this.variants.filter(variant => this.composition(variant) === value);
        if (!candidates.length) {
          event.stopImmediatePropagation();
          this.status.textContent = this.dataset.error;
          this.status.setAttribute('data-error','');
          return;
        }
        this.chooseVariant(candidates, event.target.id);
        return;
      }
      this.busy = true;
      this.setAttribute('aria-busy','true');
      this.status.removeAttribute('data-error');
      this.status.textContent = this.dataset.loading;
      this.form.querySelectorAll('[type="submit"]').forEach(button => button.disabled = true);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!this.busy) return;
        this.status.textContent = this.dataset.error;
        this.status.setAttribute('data-error','');
      }, 12000);
    }
    sync() {
      const selected = this.querySelector('[data-selected-variant]');
      if (!selected) return;
      let variant;
      try { variant = JSON.parse(selected.textContent); } catch { return; }
      if (!variant || !this.variants.some(item => item.id === variant.id)) return;
      this.variant = variant;
      const four = this.isFour(variant);
      const legacy = this.composition(variant) === 'Parure 3 pièces';
      this.sheet = this.querySelector('[data-nxp-sheet]');
      this.cases = this.querySelector('[data-nxp-cases]');
      const display = value => value.replaceAll(' x ',' × ') + ' cm';
      const sheetProperty = this.querySelector('[data-nxp-sheet-property]');
      const casesProperty = this.querySelector('[data-nxp-cases-property]');
      if (sheetProperty) sheetProperty.disabled = !four;
      casesProperty.disabled = legacy;
      this.querySelector('[data-nxp-offer-property]').value = four ? this.dataset.four : this.dataset.three;
      if (four) {
        const composition = this.composition(variant).split(' | Taies ');
        this.sheet.value = composition[0].replace('Drap-housse ','');
        this.cases.value = composition[1];
        this.markSelected(this.sheet);
        this.markSelected(this.cases);
        sheetProperty.value = display(this.sheet.value);
      } else {
        this.cases.value = legacy ? 'original' : this.composition(variant).replace('Taies ', '');
        this.markSelected(this.cases);
      }
      casesProperty.value = legacy ? '' : display(this.cases.value);
      const duvet = String(variant.option2 || variant.options[1]);
      this.querySelector('[data-nxp-duvet-property]').value = display(duvet);
      this.form.querySelector('[name="id"]').value = variant.id;
      this.form.querySelectorAll('[data-product-price]').forEach(price => price.textContent = this.money.format(variant.price / 100));
      this.form.querySelectorAll('[type="submit"]').forEach(button => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? this.dataset.add + ' — ' + this.money.format(variant.price / 100) : this.dataset.soldOut;
      });
      if (this.pendingFocusId) {
        this.querySelector('[id="' + this.pendingFocusId + '"]')?.focus({preventScroll:true});
        this.pendingFocusId = null;
      }
      this.busy = false;
      this.removeAttribute('aria-busy');
      this.status.textContent = '';
      this.status.removeAttribute('data-error');
      clearTimeout(this.timeout);
    }
  });
  const syncParures = () => document.querySelectorAll('nx-parure-configurator').forEach(configurator => {
    if (configurator.ready && !configurator.busy) configurator.sync();
  });
  const listenForProducts = () => {
    window.themeCore?.EventBus?.listen('product:loaded', syncParures);
    syncParures();
  };
  if (window.themeCore?.EventBus) listenForProducts();
  else document.addEventListener('theme:all:loaded', listenForProducts, {once:true});
  window.addEventListener('load', syncParures, {once:true});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-size-guide-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.nxSizeGuideDrawerReady) {
  window.nxSizeGuideDrawerReady = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-nx-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog?.matches('[data-nx-size-guide-dialog]')) return;
      dialog.nxGuideOpener = opener;
      dialog.nxGuideOpenerId = opener.id;
      if (!dialog.open) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-nx-size-guide-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (event.target.matches('dialog[data-nx-size-guide-dialog]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!dialog.matches?.('[data-nx-size-guide-dialog]')) return;
    const opener = dialog.nxGuideOpener?.isConnected ? dialog.nxGuideOpener : document.getElementById(dialog.nxGuideOpenerId);
    opener?.focus({preventScroll:true});
  }, true);
}
  } catch(e) { console.error(e); }
})();

})();
